import { Button, ButtonColors, ButtonHeight } from '~/components/ui/Button';
import { Text } from '~/components/ui/Text';
import { useInputAction } from '~/rage';
import { InputAction } from '~/shared';
import { useMenuLocked } from '../../hooks';
import { TabButton } from '../TabButton';
import { IButtonMenuProps } from './ButtonMenu.model';
import {
	StyledContainer,
	StyledCount,
	StyledIcon,
	StyledMenuButtonContent,
} from './ButtonMenu.styled';

const ButtonMenu = ({
	buttons,
	activeIndex,
	setActiveIndex,
	buttonsWrapper: ButtonsWrapper,
	buttonsWrapperProps,
	buttonsWrapperRef,
}: IButtonMenuProps) => {
	const { secondaryMenuLocked } = useMenuLocked();

	const handleNext = () => {
		if (!buttons.length || secondaryMenuLocked) return;
		setActiveIndex((activeIndex + 1) % buttons.length);
	};

	const handlePrev = () => {
		if (!buttons.length || secondaryMenuLocked) return;
		setActiveIndex((activeIndex - 1 + buttons.length) % buttons.length);
	};

	useInputAction(InputAction.CommonSubMenuNavLeft, handlePrev);
	useInputAction(InputAction.CommonSubMenuNavRight, handleNext);

	const buttonsContent = buttons.map((button, index) => (
		<Button
			color={activeIndex === index ? ButtonColors.Select : ButtonColors.Default}
			height={ButtonHeight.Height40}
			key={index}
			onClick={() => {
				setActiveIndex(index);
			}}
		>
			<StyledMenuButtonContent>
				<StyledIcon
					style={{
						maskImage: `url(${button.icon})`,
						WebkitMaskImage: `url(${button.icon})`,
					}}
					className="icon"
				/>
				<Text>{button.label}</Text>
				{button.count ? (
					<StyledCount>
						<Text>{button.count}</Text>
					</StyledCount>
				) : null}
			</StyledMenuButtonContent>
		</Button>
	));

	return (
		<StyledContainer>
			<TabButton>A</TabButton>
			{ButtonsWrapper ? (
				<ButtonsWrapper
					ref={buttonsWrapperRef}
					{...(buttonsWrapperProps ?? {})}
				>
					{buttonsContent}
				</ButtonsWrapper>
			) : (
				buttonsContent
			)}
			<TabButton>D</TabButton>
		</StyledContainer>
	);
};

export { ButtonMenu };
